<div class="conversation-skeleton">
  <div class="skeleton-line short"></div>
  <div class="skeleton-line"></div>
</div>
